import { A } from "@/components/standard/Html"
import { Image } from "expo-image"
import { View } from "react-native"

export const PlayStoreDownloadButton = ({
  onPress,
  width = 158,
  height = 63,
  className,
}: {
  onPress: () => void
  width?: number
  height?: number
  className?: string
}) => (
  <View
    className={`flex flex-col items-center justify-center shrink-0 ${className}`}
  >
    <A
      href="https://play.google.com/store/apps/details?id=com.dobackflip.backflip"
      onPress={onPress}
    >
      <Image
        source={require("../../assets/images/google-play-badge.png")}
        cssInterop={false}
        style={{
          width,
          height,
        }}
        contentFit="scale-down"
      />
    </A>
  </View>
)
